'use client'

import { Checkbox } from 'form-components/components/Checkbox/Checkbox'
import { ClientLabel } from 'labels/client'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useState } from 'react'

import { PRIVACY_POLICY_PAGE_PATHNAME } from '../../../../constants/privacyPolicy'

import text from 'fukku/styles/texts.module.scss'
import styles from './LegalConfirmation.module.scss'

type LabelKeys = {
	checkbox: string
	body: string
	title?: string
	errorMessage?: string
}

type LegalConfirmationProps = {
	readonly id: string
	readonly name: string
	readonly labelKeys: LabelKeys
	readonly required?: boolean
	readonly 'data-testid'?: string
}

export function LegalConfirmation({
	id,
	name,
	labelKeys: { checkbox, body, title, errorMessage },
	required,
	'data-testid': dataTestId,
}: LegalConfirmationProps) {
	const [showLegal, setShowLegal] = useState(false)
	const { t } = useLabels()

	const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
		e.preventDefault()
		setShowLegal((prevShowLegal) => !prevShowLegal)
	}

	const linkProps = {
		onClick,
		href: '/',
		className: styles.link,
		'data-testid': dataTestId,
	}

	return (
		<>
			<Checkbox
				errorMessage={errorMessage}
				id={id}
				label={<ClientLabel linkProps={linkProps}>{t(checkbox)}</ClientLabel>}
				name={name}
				required={required}
			/>
			{showLegal && (
				<div className={text.bodyS}>
					{title && <p>{t(title)}</p>}
					<p>
						<ClientLabel
							placeholderValues={{
								PrivacyPolicy: PRIVACY_POLICY_PAGE_PATHNAME,
							}}
							linkProps={{ className: styles.link }}
						>
							{t(body)}
						</ClientLabel>
					</p>
				</div>
			)}
		</>
	)
}
